<template>
    <div class="flex flex-col gap-2" :class="div_class">
        <label class="font-medium text-dark-600 dark:text-dark-400" :class="label_class">{{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <InputText :id="id" :type="type" :name="name" :placeholder="placeholder" :class="input_class"
            :value="modelValue" :disabled="disable_input" :invalid="!valid" fluid
            @input="$emit('update:modelValue', $event.target.value)" />
        <Message v-for="(item, index) in hint" :key="index" size="small" severity="secondary" variant="simple">{{ item }}
        </Message>
        <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
        </Message>
    </div>
</template>

<script>
import { InputText, Message } from 'primevue';

export default {
    name: 'InputTextCustom',
    props: {
        label: String,
        label_class: String,
        id: String,
        type: String,
        name: String,
        placeholder: String,
        input_class: String,
        modelValue: String,
        disable_input: Boolean,
        valid: Boolean,
        errorMessage: String,
        required: Boolean,
        hint: Array,
        div_class: String
    },
    components: {
        InputText, Message
    },
    emits: ['update:modelValue'],
}
</script>